<template>
  <div class="carousels-news section flex-row">
    <div class="carousels-container">
      <v-carousel
        v-model="carouselsIndex"
        height="415"
        cycle
        :show-arrows="false"
        hide-delimiter-background
        delimiter-icon="mdi-minus"
      >
        <v-carousel-item v-for="item in data" :key="item.id">
          <router-link :to="`/news/${item.id}`">
            <div
              :style="`background:url(${item.cover_url}) no-repeat center center; background-size: cover;height:100%;`"
            ></div>
          </router-link>
        </v-carousel-item>
      </v-carousel>
    </div>
    <div class="flex-col carousels-news-list">
      <h1 class="title flex-row justify-start items-center">
        <span>NEWS</span>
        <MoreVue to="/news" />
      </h1>
      <ul class="flex-col carousels-list justify-between">
        <li
          class="flex-row items-center"
          v-for="(news, i) in data"
          :key="news.id"
          :class="{ active: i === carouselsIndex }"
          @mouseover="handleCarouselChange(i)"
        >
          <div class="flex-col items-end new-date">
            <span class="date-day">{{ news.day }}</span>
            <span class="date-year">{{ news.month }}</span>
          </div>
          <div class="line"></div>
          <router-link :to="`/news/${news.id}`">
            <div class="news-title" v-text="news.topic"></div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from "@vue/composition-api";
import MoreVue from "../../../components/More.vue";
import { useFetchList } from "../../../hooks/fetch-list";
import { api } from "../../../utils/apis";
export default defineComponent({
  name: "CarouselsNews",
  components: { MoreVue },
  props: {
    type: Object,
    default: () => [],
  },
  setup(props, ctx) {
    const carouselsIndex = ref(0);
    const { data } = useFetchList({
      api: api.news.list,
      initQuery: {
        page: 1,
        page_size: 5,
      },
      ctx,
    });

    watch(
      () => data.value,
      () => {
        if (data.value.length) {
          data.value.forEach((it) => {
            const tample = it.publish_time?.split(".");
            it.day = tample[2];
            it.month = `${tample[0]}.${tample[1]}`;
          });
        }
      }
    );
    // 此处应该有防抖函数
    const handleCarouselChange = (index) => (carouselsIndex.value = index);

    return {
      carouselsIndex,
      handleCarouselChange,
      data,
    };
  },
});
</script>
<style lang="scss" scoped>
.carousels-news {
  .carousels-container {
    flex: 0 0 630px;
    height: 360px;
    border-radius: 5px;
    object-fit: cover;
    margin-right: 30px;
    overflow: hidden;
  }
  .carousels-news-list {
    flex: 0 0 630px;
  }
  .title {
    height: 33px;
    font-size: 24px;
    font-weight: 600;
    color: #1c7fbb;
    line-height: 33px;
    margin-bottom: 16px;
  }
  .carousels-list {
    padding: 0;
    height: 314px;
    li {
      height: 44px;
      overflow: hidden;
      .new-date {
        flex: 0 0 50px;
      }
      &.active {
        .date-day {
          color: #131415;
        }
        .date-year {
          color: #423e3d;
        }
        .news-title {
          color: #423e3d;
          font-weight: 600;
        }
      }
      &:hover {
        .news-title {
          color: #0364ff;
        }
      }
      cursor: pointer;
    }
    .date-day {
      height: 30px;
      font-size: 30px;
      font-weight: 600;
      color: #b1a9a7;
      line-height: 30px;
    }
    .date-year {
      height: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #b1a9a7;
      line-height: 12px;
      margin-top: 2px;
    }
    .news-title {
      max-height: 42px;
      font-size: 15px;
      font-weight: 400;
      color: #423e3d;
      line-height: 21px;
      overflow: hidden;
      flex: 0 0 660px;
    }
    .line {
      width: 1px;
      height: 40px;
      border: 1px solid #d3d3d3;
      margin: 2px 14px 2px 10px;
    }
  }
}
</style>
